// extracted by mini-css-extract-plugin
export default {"container":"Performance_container__w-c-p"};